<template>
    <v-card :loading="loading">
        <v-card-title class="text-h5">
            <v-btn
                small
                icon
                @click="close"
                color="primary"
                class="ml-n3 mr-2 my-2 py-0"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            Merge Events <v-spacer />
        </v-card-title>
        <v-divider class="ml-4 mr-5 mb-2" />
        <v-card-text class="pb-0">
            <v-data-table
                id="virtual-scroll-table"
                disable-pagination
                hide-default-footer
                :headers="headers"
                :items="filterEventElements"
                class="elevation-0"
                :mobile-breakpoint="0"
                fixed-header
                :height="$vuetify.breakpoint.mdAndDown ? '55vh' : '55vh'"
                :loading="loading"
            >
                <template v-slot:top>
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pb-0 align-center"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <v-col cols="12">
                            <h2 class="ml-4">
                                {{
                                    eventElements.filter(e => e.selected).length
                                }}
                                Events Selected
                            </h2>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`header.project`]="{ header }">
                    <v-text-field
                        :label="header.text"
                        v-model="projectToFilter"
                        dense
                        class="pt-2"
                    />
                </template>
                <template v-slot:[`header.packingList`]="{ header }">
                    <v-text-field
                        :label="header.text"
                        v-model="packingListToFilter"
                        dense
                        class="pt-2"
                    />
                </template>
                <template v-slot:[`header.workOrders`]="{ header }">
                    <v-text-field
                        :label="header.text"
                        v-model="workOrdersToFilter"
                        dense
                        class="pt-2"
                    />
                </template>
                <template v-slot:[`header.container`]="{ header }">
                    <v-text-field
                        :label="header.text"
                        v-model="containerToFilter"
                        dense
                        class="pt-2"
                    />
                </template>
                <template v-slot:[`header.requestedShipmentDate`]="{ header }">
                    <v-text-field
                        :label="header.text"
                        v-model="requestedShipmentDateToFilter"
                        dense
                        class="pt-2"
                    />
                </template>
                <template v-slot:[`header.scheduledFor`]="{ header }">
                    <v-text-field
                        :label="header.text"
                        v-model="scheduledForToFilter"
                        dense
                        class="pt-2"
                    />
                </template>
                <template v-slot:[`header.status`]="{ header }">
                    <v-text-field
                        :label="header.text"
                        v-model="statusToFilter"
                        dense
                        class="pt-2"
                    />
                </template>
                <template v-slot:[`item.project`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{
                                item.project
                                    ? `${item.project.name || ''} - ${item
                                          .project.reference || ''} `
                                    : ''
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.packingList`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.name }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.workOrders`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{
                                item.packingList.selectedWorkOrders
                                    ? item.packingList.selectedWorkOrders
                                          .map(wo => wo.code)
                                          .join(', ')
                                    : ''
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.container`]="{ item }">
                    <div class="d-flex justify-center align-center">
                        <p class="my-0 text-capitalize mr-2">
                            {{ item.packingList.container || '-' }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.requestedShipmentDate`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{
                                item.packingList.requestedShipmentDate
                                    ? item.packingList.requestedShipmentDate
                                    : '-'
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.scheduledFor`]="{ item }">
                    <div class="d-flex justify-center align-center">
                        <p class="my-0 text-capitalize mr-2">
                            {{
                                item.packingList.scheduledFor
                                    ? item.packingList.scheduledFor
                                    : '-'
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.airShipment`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{ item.packingList.airShipment ? 'Yes' : 'No' }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <div class="d-flex justify-center">
                        <p class="my-0 text-capitalize">
                            {{
                                item.packingList.status
                                    ? item.packingList.status
                                    : '-'
                            }}
                        </p>
                    </div>
                </template>
                <template v-slot:[`item.select`]="{ item }">
                    <div class="d-flex justify-center">
                        <v-checkbox
                            v-model="item.selected"
                            :label="''"
                            hide-details
                            class="ma-0"
                        />
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <v-btn
                rounded
                @click="openConfirmMergeDialog"
                color="primary"
                class="ml-n3 mr-2 mt-0 mb-2 py-0"
                :disabled="eventElements.filter(e => e.selected).length < 2"
            >
                NEXT
            </v-btn>
        </v-card-actions>

        <v-dialog v-model="confirmMergeDialog" max-width="900px">
            <v-card>
                <v-card-title class="text-h5">
                    <v-btn
                        small
                        icon
                        @click="closeConfirmMergeDialog"
                        color="primary"
                        class="ml-n3 mr-2 my-2 py-0"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    Confirm Merge
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider class="ml-4 mr-5 mb-2" />
                <v-card-text class="pb-0">
                    <v-data-table
                        :headers="dialogHeaders"
                        :items="selectedElements"
                        hide-default-footer
                        disable-pagination
                        class="elevation-1"
                        :mobile-breakpoint="0"
                        fixed-header
                        :height="
                            $vuetify.breakpoint.mdAndDown ? '45vh' : '45vh'
                        "
                        :loading="loading"
                    >
                        <template v-slot:[`item.airShipment`]="{ item }">
                            <div class="d-flex justify-center">
                                <p class="my-0 text-capitalize">
                                    {{
                                        item.packingList.airShipment
                                            ? 'Yes'
                                            : 'No'
                                    }}
                                </p>
                                <v-btn
                                    v-if="
                                        item.packingList.airShipment !== null &&
                                            item.packingList.airShipment !==
                                                undefined
                                    "
                                    icon
                                    small
                                    @click="
                                        setDialogAirShipment(
                                            item.packingList.airShipment
                                        )
                                    "
                                >
                                    <v-icon color="primary"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </div>
                        </template>
                        <template v-slot:[`item.packingList`]="{ item }">
                            <div class="d-flex justify-center">
                                <p class="my-0 text-capitalize">
                                    {{ item.name }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.project`]="{ item }">
                            <div class="d-flex justify-center">
                                <p class="my-0 text-capitalize">
                                    {{
                                        item.project
                                            ? `${item.project.name ||
                                                  ''} - ${item.project
                                                  .reference || ''} `
                                            : ''
                                    }}
                                </p>
                            </div>
                        </template>
                        <template v-slot:[`item.container`]="{ item }">
                            <div class="d-flex justify-center align-center">
                                <p class="my-0 text-capitalize mr-2">
                                    {{ item.packingList.container || '-' }}
                                </p>
                                <v-btn
                                    v-if="item.packingList.container"
                                    icon
                                    small
                                    @click="
                                        setDialogContainer(
                                            item.packingList.container
                                        )
                                    "
                                >
                                    <v-icon color="primary"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </div>
                        </template>
                        <template v-slot:[`item.scheduledFor`]="{ item }">
                            <div class="d-flex justify-center align-center">
                                <p class="my-0 text-capitalize mr-2">
                                    {{
                                        item.packingList.scheduledFor
                                            ? item.packingList.scheduledFor
                                            : '-'
                                    }}
                                </p>
                                <v-btn
                                    v-if="item.packingList.scheduledFor"
                                    icon
                                    small
                                    :disabled="
                                        isDateInPast(
                                            item.packingList.scheduledFor
                                        )
                                    "
                                    @click="
                                        setDialogScheduledFor(
                                            item.packingList.scheduledFor
                                        )
                                    "
                                >
                                    <v-icon color="primary"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>

                    <v-form v-model="valid">
                        <v-row class="mt-4">
                            <v-col cols="12" md="4">
                                <v-menu
                                    v-model="dateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="newScheduledFor"
                                            label="Scheduled For"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            outlined
                                            dense
                                            required
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="newScheduledFor"
                                        @input="dateMenu = false"
                                        :min="minDate"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    label="Container"
                                    v-model="newContainer"
                                    prepend-icon="mdi-package"
                                    outlined
                                    dense
                                    required
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    v-model="newAirShipment"
                                    :items="airShipmentOptions"
                                    item-text="text"
                                    item-value="value"
                                    label="Air Shipment"
                                    prepend-icon="mdi-airplane"
                                    outlined
                                    dense
                                    required
                                    :rules="[rules.required]"
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0 pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="confirmMerge"
                        rounded
                        :disabled="!valid"
                    >
                        CONFIRM
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import moment from 'moment'

export default {
    name: 'MergeDialog',
    props: {
        events: {
            type: Array,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        expanded: [],
        headers: [
            {
                text: 'SELECT',
                value: 'select',
                align: 'center',
                sortable: false,
                width: 80,
            },
            {
                text: 'PACKING LIST',
                value: 'packingList',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'CONTAINER',
                value: 'container',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'center',
                sortable: false,
                width: 210,
            },
            {
                text: 'WORK ORDERS',
                value: 'workOrders',
                align: 'center',
                sortable: false,
                width: 160,
            },
            {
                text: 'REQUESTED SHIPMENT DATE',
                value: 'requestedShipmentDate',
                align: 'center',
                sortable: false,
                width: 130,
            },
            {
                text: 'SCHEDULED FOR',
                value: 'scheduledFor',
                align: 'center',
                sortable: false,
                width: 140,
            },
            {
                text: 'AIR SHIPMENT',
                value: 'airShipment',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'STATUS',
                value: 'status',
                align: 'center',
                sortable: false,
                width: 100,
            },
        ],
        // Nuevas propiedades para el diálogo de fusión
        confirmMergeDialog: false,
        newContainer: null,
        newAirShipment: null,
        newScheduledFor: null,
        dateMenu: false,
        dialogHeaders: [
            {
                text: 'PACKING LIST',
                value: 'packingList',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'center',
                sortable: false,
                width: 210,
            },
            {
                text: 'CONTAINER',
                value: 'container',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'AIR SHIPMENT',
                value: 'airShipment',
                align: 'center',
                sortable: false,
                width: 120,
            },
            {
                text: 'SCHEDULED FOR',
                value: 'scheduledFor',
                align: 'center',
                sortable: false,
                width: 140,
            },
        ],
        selectedProject: {},
        selectedOrder: {},
        packingListForm: false,
        processPackingList: false,
        createPackingList: false,
        openExistentPackingLists: false,
        eventElements: [],
        packingListToFilter: undefined,
        containerToFilter: undefined,
        workOrdersToFilter: undefined,
        requestedShipmentDateToFilter: undefined,
        scheduledForToFilter: undefined,
        statusToFilter: undefined,
        projectToFilter: undefined,
        airShipmentOptions: [
            { text: 'Yes', value: true },
            { text: 'No', value: false },
        ],
        selectedElements: [],
        valid: false,
        rules: {
            required: value =>
                (value != null && value !== '' && value !== undefined) ||
                'Required.',
        },
    }),
    computed: {
        filterEventElements() {
            let conditions = []

            if (!this.user.permissions.includes('updateWOProcesses')) {
                conditions.push(this.filterByProjectManager)
                conditions.push(this.filterByMergedWithSameProject)
            }

            if (this.packingListToFilter) {
                conditions.push(this.filterForPackingList)
            }
            if (this.containerToFilter) {
                conditions.push(this.filterForContainer)
            }
            if (this.projectToFilter) {
                conditions.push(this.filterForProject)
            }
            if (this.workOrdersToFilter) {
                conditions.push(this.filterForWorkOrders)
            }
            if (this.requestedShipmentDateToFilter) {
                conditions.push(this.filterForRequestedShipmentDate)
            }
            if (this.scheduledForToFilter) {
                conditions.push(this.filterForScheduledFor)
            }

            if (this.statusToFilter) {
                conditions.push(this.filterForStatus)
            }

            if (conditions.length > 0) {
                return this.eventElements.filter(request => {
                    return conditions.every(condition => {
                        return condition(request)
                    })
                })
            }
            return this.eventElements
        },
        minDate() {
            // Retorna la fecha actual en formato YYYY-MM-DD para deshabilitar fechas pasadas
            const today = new Date()
            return today.toISOString().split('T')[0]
        },
    },
    async mounted() {
        try {
            this.events = this.events.filter(e => e.elements)
            this.events.forEach(event => {
                let merged = event.elements && event.elements.length > 1
                let mergedWithSameProject =
                    event.elements.filter(
                        e =>
                            e.project &&
                            e.project.id === event.elements[0]?.project?.id
                    ).length === event.elements.length

                event.elements.forEach(element => {
                    element.merged = merged
                    element.mergedWithSameProject = mergedWithSameProject
                })
                this.eventElements.push(...event.elements)
            })
            this.eventElements = this.eventElements.filter(
                e => !['shipped', 'completed'].includes(e.packingList.status)
            )
            this.eventElements.forEach(element => {
                element.packingList.airShipment =
                    element.packingList.airShipment || false
            })
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        close() {
            this.$emit('close')
        },
        filterForPackingList(element) {
            return (
                element.name &&
                element.name
                    .toLowerCase()
                    .includes(this.packingListToFilter.toLowerCase())
            )
        },
        filterForContainer(element) {
            return (
                element.packingList &&
                element.packingList.container &&
                element.packingList.container
                    .toLowerCase()
                    .includes(this.containerToFilter.toLowerCase())
            )
        },
        filterForWorkOrders(element) {
            return (
                element.packingList &&
                element.packingList.selectedWorkOrders &&
                element.packingList.selectedWorkOrders
                    .map(wo => wo.code)
                    .join(', ')
                    .toLowerCase()
                    .includes(this.workOrdersToFilter.toLowerCase())
            )
        },
        filterForRequestedShipmentDate(element) {
            return (
                element.packingList &&
                element.packingList.requestedShipmentDate &&
                element.packingList.requestedShipmentDate
                    .toLowerCase()
                    .includes(this.requestedShipmentDateToFilter.toLowerCase())
            )
        },
        filterForScheduledFor(element) {
            return (
                element.packingList &&
                element.packingList.scheduledFor &&
                element.packingList.scheduledFor
                    .toLowerCase()
                    .includes(this.scheduledForToFilter.toLowerCase())
            )
        },

        filterForStatus(element) {
            return (
                element.packingList &&
                element.packingList.status &&
                element.packingList.status
                    .toLowerCase()
                    .includes(this.statusToFilter.toLowerCase())
            )
        },
        filterForProject(element) {
            return (
                element.project &&
                element.project.name &&
                element.project.reference &&
                (element.project.reference
                    .toString()
                    .toLowerCase()
                    .includes(this.projectToFilter.toLowerCase()) ||
                    element.project.name
                        .toLowerCase()
                        .includes(this.projectToFilter.toLowerCase()))
            )
        },
        filterByProjectManager(element) {
            return (
                element.project &&
                element.project.projectManager &&
                element.project.projectManager == this.user?.id
            )
        },
        filterByMergedWithSameProject(element) {
            return element.mergedWithSameProject
        },
        openConfirmMergeDialog() {
            this.selectedElements = this.eventElements.filter(e => e.selected)
            this.confirmMergeDialog = true
        },
        setDialogContainer(container) {
            this.newContainer = container
        },
        setDialogAirShipment(airShipment) {
            this.newAirShipment = airShipment
        },
        setDialogScheduledFor(date) {
            this.newScheduledFor = new Date(date).toISOString().split('T')[0]
        },
        isDateInPast(date) {
            const inputDate = moment(date).startOf('day')
            const today = moment().startOf('day')
            return inputDate.isBefore(today)
        },
        async confirmMerge() {
            try {
                this.loading = true
                for (const selectedElement of this.selectedElements) {
                    if (
                        selectedElement.scheduledFor != this.newScheduledFor ||
                        selectedElement.container != this.newContainer ||
                        selectedElement.airShipment != this.newAirShipment
                    )
                        await API.updatePackingList({
                            projectId: selectedElement.project?.id,
                            packingListId: selectedElement.packingList?.id,
                            scheduledFor: this.newScheduledFor,
                            container: this.newContainer,
                            airShipment: this.newAirShipment,
                        })
                }

                const selectedPackingLists = this.selectedElements.map(
                    e => e.packingList?.id
                )

                this.$emit('mergeConfirmed', {
                    selectedPackingLists,
                    newScheduledFor: this.newScheduledFor,
                    newContainer: this.newContainer,
                    newAirShipment: this.newAirShipment,
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeConfirmMergeDialog() {
            this.confirmMergeDialog = false
            this.newContainer = null
            this.newAirShipment = null
            this.newScheduledFor = null
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}
.v-data-table {
    border: 1px solid #eeeeee;
}
</style>
